<div *ngIf="isNewChatbotEnabled && showSuggestions"
  class="suggestions-box"
>
  <h4 *ngIf="showSuggestions" class="suggestions-title">{{'DOMAIN_SWITCH_TITLE' | translate}}</h4>
  <div
    class="suggestion"
    *ngFor="let suggestion of filteredSuggestions; let i = index"
    (click)="selectSuggestion(suggestion)"
    [ngClass]="{ 'selected-suggestion': i === selectedSuggestionIndex }"
  >
    <div class="domain-info">
      <img [src]="getdomainIcon(suggestion)" alt="domain icon" class="domain-icon">
      <div class="domain-name">{{ getDomainFullName(suggestion) }} ({{suggestion}})</div>
    </div>
  </div>
</div>

<div *ngIf="!isNewChatbotEnabled && allDomainNames.length > 0"  class="domain-switch-wrapper">
  <button class="domain-button" (click)="openDomainPopup()" [class.open]="showDomainPopup">
    <img *ngIf="selectedDomain || allDomainNames[0]" [src]="getdomainIcon(selectedDomain || allDomainNames[0])" alt="domain icon" class="domain-icon">
    <span *ngIf="selectedDomain || allDomainNames[0]" class="domain-text">{{ selectedDomain || allDomainNames[0] }}</span>
    <span class="caret"></span>
  </button>

  <div *ngIf="showDomainPopup && allDomainNames.length > 0" class="domain-popup-content dropdown-menu">
    <ul class="domain-list">
      <li *ngFor="let domain of allDomainNames" (click)="selectSuggestion(domain)" class="domain-item-list">
        <img [src]="getdomainIcon(domain)" alt="domain icon" class="domain-icon">
        <div class="domain-name">{{ getDomainFullName(domain) }} ({{domain}})</div>
      </li>
    </ul>
  </div>
</div>
